import React from 'react';
import PropTypes from 'prop-types';
import { productStructuredData } from '@utils/structuredData';

const StructuredData = ({ name, imageUrl, url, price, availability }) => {
  return price ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
          productStructuredData(name, imageUrl, url, price, availability)
        ),
      }}
    ></script>
  ) : null;
};

export default StructuredData;

StructuredData.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  price: PropTypes.number,
  availability: PropTypes.string,
};
